import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';

// The circular back control on detail surfaces (Vault entry, Membership).
//
// Extracted because VaultEntry already carried this exact markup twice — once
// for its desktop header, once for its mobile one — and Membership would have
// made it four copies. PageHeader's own header note says a page needing a back
// button should compose its own header rather than widening PageHeader; this
// is the piece those hand-rolled headers should NOT each re-roll.
//
// ONE SIZE, 44px. VaultEntry's mobile copy was 40px, which is under the 44x44
// minimum DESIGN.md §17.6 mandates — and the phone is the breakpoint the rule
// exists for. Unifying up rather than preserving both sizes fixes that on the
// way past.
//
// `to` is a destination, not history.back(). A detail page reached from a deep
// link, a Stripe redirect, or a fresh tab has no history to return to, and a
// back arrow that does nothing on those entries is worse than one that always
// lands somewhere sensible.
export default function BackButton({
  to,
  label,
  className = '',
  'data-testid': testId = 'back-button',
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      aria-label={label}
      data-testid={testId}
      className={[
        'w-11 h-11 rounded-full bg-[#232322] border border-hairline-soft',
        'flex items-center justify-center text-bone shrink-0 cursor-pointer',
        'transition-colors duration-200 ease-mogged hover:border-[rgba(255,255,255,0.35)]',
        className,
      ].filter(Boolean).join(' ')}
    >
      <LuArrowLeft size={18} aria-hidden="true" />
    </button>
  );
}
